// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".group-selector{background-color:#222;bottom:0;left:0;overflow-y:scroll;padding:20px;position:fixed;right:0;top:0}.group-selector__header{margin-top:56px;text-align:center}.group-selector__header h1{color:#fff}.group-selector__choices{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center;padding:60px}.group-selector__choices .group-selector-item{background-color:#4a657f;flex:0 0 350px;margin:10px;min-height:50px}", ""]);
// Exports
module.exports = exports;
